import { ArrowSquareOut, ArrowsClockwise } from '@phosphor-icons/react';

const LEDGER_SCREEN = {
  mfg: '/mfg/items', eng: '/engineering/assets', office: '/bihin/items',
  equip: '/mfg/equipment', it: '/it/assets',
};

const MAKE_LABEL = { purchased: '購入品', in_house: '自社製作' };

const yen = (v) => (v === null || v === undefined || v === '' ? null : `¥${Number(v).toLocaleString()}`);

/**
 * R3 fix · 選んだ既存品目の「マスターの値」をそのまま読み取り専用で見せるカード。
 *
 * マスターに在る項目は、この画面では**直せない**（直すのは「マスターを編集」から）。
 * 空の値は「未登録」と出す — 空欄だと入力待ちに見えてしまうため。
 */
export const MasterItemSummary = ({ item, testId = 'master-summary', onRefresh }) => {
  if (!item) return null;
  const rows = [
    ['品番', item.sku],
    ['品名', item.name],
    ['型式・仕様', item.model_no],
    ['メーカー', item.maker],
    ['メーカー品番', item.maker_pn],
    ['図番 / Rev', [item.drawing_no, item.drawing_revision].filter(Boolean).join(' ')],
    ['材質', item.material],
    ['単位', item.uom],
    ['入数', item.pack_qty],
    ['直近単価', yen(item.last_price)],
    ['仕入先', item.supplier_name],
    ['製作区分', MAKE_LABEL[item.make_type]],
    ['在庫', item.on_hand === null || item.on_hand === undefined
      ? null : `${item.on_hand}${item.uom || ''}`],
  ];
  return (
    <div className="rounded-lg border border-zinc-200 bg-zinc-50/70 p-3" data-testid={testId}>
      <div className="grid grid-cols-2 gap-x-4 gap-y-1.5 sm:grid-cols-3">
        {rows.map(([label, value]) => (
          <div key={label}>
            <p className="text-[10px] font-semibold text-zinc-500">{label}</p>
            <p className={`text-[12px] ${value ? 'text-zinc-900' : 'text-zinc-400'}`}
              data-testid={`${testId}-${label}`}>
              {value || '未登録'}
            </p>
          </div>
        ))}
      </div>
      <div className="mt-2 flex flex-wrap items-center gap-3 border-t border-zinc-200 pt-2">
        <a href={LEDGER_SCREEN[item.source] || '/mfg/items'} target="_blank" rel="noreferrer"
          className="inline-flex items-center gap-1 text-[11px] font-semibold text-teal-700 hover:text-teal-900"
          data-testid={`${testId}-edit-master`}>
          <ArrowSquareOut size={12} weight="bold" /> マスターを編集
        </a>
        {onRefresh && (
          <button type="button" onClick={onRefresh}
            className="inline-flex items-center gap-1 text-[11px] font-semibold text-zinc-600 hover:text-zinc-900"
            data-testid={`${testId}-refresh`}>
            <ArrowsClockwise size={12} weight="bold" /> 編集したら読み込み直す
          </button>
        )}
        {item.reference_url && (
          <a href={item.reference_url} target="_blank" rel="noreferrer"
            className="inline-flex items-center gap-1 text-[11px] text-zinc-600 hover:text-zinc-900"
            data-testid={`${testId}-url`}>
            <ArrowSquareOut size={12} /> 参考URL
          </a>
        )}
        <span className="ml-auto text-[10px] text-zinc-500" data-testid={`${testId}-note`}>
          マスターに在る項目はここでは直せません
        </span>
      </div>
    </div>
  );
};

export default MasterItemSummary;
